// @i18n-ignore-file
export const PAGE_PATH = {
  MY_ORDERS_RETURNS: 'account/my-orders-returns',
  MY_PROFILE: 'account/my-profile',
  ADDRESSES: 'account/addresses',
  PAYMENTS: 'account/payments',
  MY_REWARDS: 'account/my-rewards',
  MY_STORE_CREDITS: 'account/my-store-credit',
  ORDERS_CANCEL: 'accounts/cancel',
  ORDERS_RETURNS: 'account/returns',
  MY_SUBSCRIPTIONS: 'account/my-subscriptions',
  MENU: 'account/menu',
  CONTACT_US: 'contact-us',
  LOG_IN: 'log-in',
  REFER_AND_EARN: 'refer-and-earn',
  SEARCH: 'search',
  SIGN_UP: 'sign-up',
  WISHLIST: 'wishlist',
  TRACKING: 'tracking',
  HOME: '/',
  FIND_MY_ORDER: 'find-my-order',
  MY_ORDERS_RETURNS_ROUTE: '/account/my-orders-returns',
  COMMUNICATION_PREFERENCES: 'communication-preferences',
  TRADE: 'trade',
  INTERIOR_DESIGN: 'business/interior-design',
  HOSPITALITY: 'business/hospitality',
  MY_SUBSCRIPTIONS_DETAILS: 'account/subscriptions',
  REVIEWS_SESSION: 'reviews/session',
}

/** Exact path → i18n namespace. Prefer this for static routes. */
export const pathToNameSpaceMap: Record<string, string> = {
  // eslint-disable-next-line i18next/no-literal-string
  [PAGE_PATH.WISHLIST]: 'wishlist',
  // eslint-disable-next-line i18next/no-literal-string
  [PAGE_PATH.MY_ORDERS_RETURNS]: 'postOrder',
  // eslint-disable-next-line i18next/no-literal-string
  [PAGE_PATH.ORDERS_RETURNS]: 'postOrder',
  // eslint-disable-next-line i18next/no-literal-string
  [PAGE_PATH.MY_SUBSCRIPTIONS]: 'postOrder',
  // eslint-disable-next-line i18next/no-literal-string
  [PAGE_PATH.MY_SUBSCRIPTIONS_DETAILS]: 'postOrder',
}

/** Pattern-based fallbacks for dynamic paths (e.g. catch-all). Evaluated after pathToNameSpaceMap. */
const pathPatternToNamespace: { test: (path: string) => boolean; namespace: string }[] = [
  { test: path => /^account\/orders\/\d+\/return$/.test(path), namespace: 'postOrder' },
]

const DEFAULT_NAMESPACE = 'common'

/** Resolves the i18n namespace for a path: map first, then patterns, then default. */
export function getI18nNamespaceForPath(pathName: string): string {
  const exact = pathToNameSpaceMap[pathName]
  if (exact) return exact
  const byPattern = pathPatternToNamespace.find(entry => entry.test(pathName))
  return byPattern?.namespace ?? DEFAULT_NAMESPACE
}
